import * as _ from "lodash";
import http from "../constant/api";

export const StaffService = {
  readStaff: async () => {
    const result = await http.get(`/api/staff/read`);

    return result;
  },
  listStaff: async () => {
    const result = await http.get(`/api/staff/list`);

    return result;
  },
  listStaffOnline: async () => {
    const result = await http.get(`/api/staff/list/online`);

    return result;
  },
  listStaffByGroupId: async (groupId) => {
    const result = await http.get(`/api/staff/list/group-id/${groupId}`);

    return result;
  },
};
